export default function escapeList(options) {
  return {
    onKeyDown(event, change, editor) {
      if (event.key !== 'Enter') return;
      const { value } = editor;
      const { startBlock } = value;
      const { type } = startBlock;
      if (
        type === 'list-item' &&
        startBlock.nodes.get(0).text === ''
      ) {
        event.preventDefault();
        return change
          .unwrapBlock('bulleted-list')
          .unwrapBlock('numbered-list')
          .setBlocks('paragraph');
      }
    },
  };
}
